var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-table',{ref:"affiliate",attrs:{"url":_vm.affiliateUrl,"attributes":[
      {
        attribute: 'description',
        name: 'Beschreibung'
      },
      {
        attribute: 'slug',
        name: 'Trackingcode',
        type: 'CopyClipboardCell'
      },
      {
        attribute: 'partner',
        name: 'Werbepartner'
      },
      {
        attribute: 'quota',
        name: 'Kontingent'
      },
      {
        attribute: 'cpm',
        name: 'TKP',
        type: 'CurrencyCell'
      },
      {
        attribute: 'cpl',
        name: 'CPL',
        type: 'CurrencyCell'
      },
      {
        attribute: 'oi_today',
        name: 'Mitglieder heute'
      },
      {
        attribute: 'oi_total',
        name: 'Mitglieder gesamt'
      },
      {
        attribute: 'page_visits',
        name: 'Seitenaufrufe Heute / Gesamt'
      },
      {
        attribute: 'type',
        name: 'SOI / DOI'
      }
    ]}}),_vm._v(" "),_c('v-table',{attrs:{"url":_vm.userUrl,"attributes":[
      {
        attribute: 'censored_membername',
        name: 'Name'
      },
      {
        attribute: 'censored_email',
        name: 'Email-Provider'
      },
      {
        attribute: 'pivot.created_at',
        type: 'DateTimeCell',
        name: 'Registriert'
      },
      {
        attribute: 'additional_affiliate_parameter.parameters',
        type: 'ModalCell',
        modal: 'PublicAffiliateParametersModal',
        mode: 'additionalParameters',
        name: 'Übergebene Parameter'
      }
    ]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }